"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbToHex = void 0;
var tslib_1 = require("tslib");
var rgbToHex = function (_a) {
    var _b = tslib_1.__read(_a, 3), r = _b[0], g = _b[1], b = _b[2];
    var r16 = r.toString(16).padStart(2, '0');
    var g16 = g.toString(16).padStart(2, '0');
    var b16 = b.toString(16).padStart(2, '0');
    return "#".concat(r16).concat(g16).concat(b16);
};
exports.rgbToHex = rgbToHex;
